module.exports = __webpack_public_path__ + "static/staw_thumb-48f24092c857e772fc36bc6d7ded4709.jpg";